import { render } from "./balances-pay-publish.vue?vue&type=template&id=4187e24e&scoped=true"
import script from "./balances-pay-publish.vue?vue&type=script&lang=js"
export * from "./balances-pay-publish.vue?vue&type=script&lang=js"

import "./balances-pay-publish.vue?vue&type=style&index=0&id=4187e24e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4187e24e"]])

export default __exports__